import React, { Component } from 'react';
import Helmet from 'react-helmet';
import {renderRoutes} from 'react-router-config';

import DefaultLayout from '../../../Layout/DefaultLayout.jsx';

export default class EditDo extends Component {
  render() {
    const helmet = <Helmet>
      <title>Édition de mon profil</title>
    </Helmet>;

    return (
      <DefaultLayout className="edit-do" helmet={helmet}>
        <div className="bg-gray-50">
          <div className="container">
            <div className="row">
              <div className="col mx-auto p-5 my-5">
                {renderRoutes(this.props.route.routes, { 
                  currentUser: this.props.currentUser,
                  updateUser: this.props.updateUser,
                  submitUser: this.props.submitUser,
                  onFormSuccess: this.props.onFormSuccess,
                  currentStep: this.props.currentStep,
                  edit: true
                })}
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    );
  }
}
